var _g, _ellipse, _ellipse2, _path, _ellipse3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMcpLight = function SvgMcpLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 62,
    fill: "none",
    viewBox: "0 0 64 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mcp-light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M58.594 29h-54"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 61.188,
    x: 26,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#mcp-light_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#mcp-light_svg__c)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.594,
    cy: 28,
    fill: "url(#mcp-light_svg__d)",
    rx: 8,
    ry: 20
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M44.594 8.5c.922 0 1.852.465 2.75 1.415.9.95 1.732 2.354 2.442 4.129 1.419 3.547 2.308 8.48 2.308 13.956s-.89 10.41-2.308 13.956c-.71 1.775-1.542 3.178-2.441 4.129S45.517 47.5 44.594 47.5s-1.853-.465-2.751-1.415c-.9-.95-1.732-2.354-2.442-4.129-1.418-3.547-2.307-8.48-2.307-13.956s.889-10.41 2.307-13.956c.71-1.775 1.543-3.178 2.442-4.129.898-.95 1.828-1.415 2.75-1.415Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 61.188,
    x: 13,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#mcp-light_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#mcp-light_svg__f)",
    shapeRendering: "crispEdges"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.594,
    cy: 28,
    fill: "url(#mcp-light_svg__g)",
    fillOpacity: 0.5,
    rx: 8,
    ry: 20
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.594,
    cy: 28,
    fill: "url(#mcp-light_svg__h)",
    fillOpacity: 0.25,
    rx: 8,
    ry: 20,
    style: {
      mixBlendMode: "screen"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M31.594 8.5c.922 0 1.852.465 2.75 1.415.9.95 1.732 2.354 2.442 4.129 1.419 3.547 2.308 8.48 2.308 13.956s-.89 10.41-2.308 13.956c-.71 1.775-1.542 3.178-2.441 4.129S32.517 47.5 31.594 47.5s-1.853-.465-2.751-1.415c-.9-.95-1.732-2.354-2.442-4.129-1.418-3.547-2.307-8.48-2.307-13.956s.889-10.41 2.307-13.956c.71-1.775 1.543-3.178 2.442-4.129.898-.95 1.828-1.415 2.75-1.415Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 61.188,
    x: 0,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#mcp-light_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#mcp-light_svg__j)",
    shapeRendering: "crispEdges"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.594,
    cy: 28,
    fill: "url(#mcp-light_svg__k)",
    fillOpacity: 0.2,
    rx: 8,
    ry: 20
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.594,
    cy: 28,
    fill: "url(#mcp-light_svg__l)",
    rx: 8,
    ry: 20,
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeOpacity: 0.05,
    d: "M18.594 8.5c.922 0 1.852.465 2.75 1.415.9.95 1.732 2.354 2.442 4.129 1.419 3.547 2.308 8.48 2.308 13.956s-.89 10.41-2.308 13.956c-.71 1.775-1.542 3.178-2.441 4.129S19.517 47.5 18.594 47.5s-1.853-.465-2.751-1.415c-.9-.95-1.732-2.354-2.442-4.129-1.418-3.547-2.307-8.48-2.307-13.956s.889-10.41 2.307-13.956c.71-1.775 1.543-3.178 2.442-4.129.898-.95 1.828-1.415 2.75-1.415Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mcp-light_svg__a",
    width: 58,
    height: 4,
    x: 2.594,
    y: 28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26749"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26749",
    result: "effect2_dropShadow_2555_26749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26749",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mcp-light_svg__c",
    width: 37.188,
    height: 61.188,
    x: 26,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26749",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mcp-light_svg__f",
    width: 37.188,
    height: 61.188,
    x: 13,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26749",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mcp-light_svg__j",
    width: 37.188,
    height: 61.188,
    x: 0,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26749",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcp-light_svg__d",
    x1: 45.115,
    x2: 45.115,
    y1: 8.535,
    y2: 68.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcp-light_svg__g",
    x1: 31.594,
    x2: 31.594,
    y1: 25.75,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcp-light_svg__k",
    x1: 18.594,
    x2: 18.594,
    y1: 25.75,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mcp-light_svg__b",
    transform: "translate(-26 -.055)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.594,
    cy: 28,
    rx: 8,
    ry: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mcp-light_svg__e",
    transform: "translate(-13 -.055)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.594,
    cy: 28,
    rx: 8,
    ry: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mcp-light_svg__i",
    transform: "translate(0 -.055)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.594,
    cy: 28,
    rx: 8,
    ry: 20
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mcp-light_svg__h",
    width: 4,
    height: 1.6,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mcp-light_svg__m",
    transform: "scale(.0039 .00156)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mcp-light_svg__l",
    width: 4,
    height: 1.6,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mcp-light_svg__m",
    transform: "scale(.0039 .00156)"
  })))));
};
export default SvgMcpLight;